<template>
    <div class="banner-collection-info">
        <div class="banner-collection-info__container">
            <span class="banner-collection-info__label" v-html="$t('Collection.course_collection')"></span>
            <h1 class="banner-collection-info__title">
                {{ title }}
            </h1>
            <Breadcrumb/>
            <BannerCollectionInfo
                v-if="categories.length > 0 || levels.length > 0"
                :categories="categories"
                :levels="levels"
                :publishDate="publishDate"
                :expirationDate="expirationDate"
                :lastUpdatedDate="lastUpdatedDate"
            />
            <TotemAddToWatchlistButton
                v-if="showAddToFavourite"
                type="collection"
                :elementId="collectionId"
            />
            <span v-if="isLoggedIn" class="icon-info" v-tooltip="{ content: $t('BannerCollectionInfo.please_note_bla_bla'), html: true }"></span>
            <div class="banner-collection-info__description -v-html" v-if="description"
                 v-html="truncateDescription"></div>

            <div class="banner-collection-info__actions">
                <div class="banner-collection-info__read-more" @click="openDescriptionModal" v-if="showReadMore">
                    <span v-html="$t('General.read_more')"></span>
                    <span class="icon-plus"></span>
                </div>
            </div>
        </div>

        <modal
            name="collection-description"
            width="80%"
            :maxWidth="1200"
            height="auto"
            :adaptive="true"
            :scrollable="true"
        >
            <div class="banner-collection-info__modal">
                <h1 class="banner-collection-info__title">
                    <span v-html="$t('Collection.course_collection')"></span>
                    {{ title }}
                </h1>
                <span class="icon-clear banner-collection-info__close-button" @click="closeModal"></span>
                <div class="banner-collection-info__description -modal -v-html" v-html="description"></div>
            </div>
        </modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import BannerCollectionInfo from './BannerCollectionInfo'
    import Breadcrumb from 'components/breadcrumb/breadcrumb'

    export default {
        components: { BannerCollectionInfo, Breadcrumb },
        props: {
            collectionId: [ Number, String ],
            title: String,
            description: String,
            categories: Array,
            levels: Array,
            publishDate: String,
            expirationDate: String,
            lastUpdatedDate: String
        },
        data () {
            return {
                collectionToNewWatchlist: null,
                desktopDescLength: 650,
                mobileDescLength: 200
            }
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn'
            }),
            showAddToFavourite () {
                return this.isLoggedIn
            },
            truncateDescription () {
                let length = this.isDesktopView ? this.desktopDescLength : this.mobileDescLength
                if (this.description.length < length) {
                    return this.description
                } else {
                    return this.description.substring(0, length) + '...'
                }
            },
            showReadMore () {
                return this.isDesktopView ? this.description.length > this.desktopDescLength : this.description.length > this.mobileDescLength
            },
        },
        methods: {
            openDescriptionModal () {
                this.$modal.show('collection-description')
            },
            closeModal () {
                this.$modal.hide('collection-description')
            }
        }
    }
</script>

<style lang="scss" scoped>

    .banner-collection-info {
        position: relative;
        flex-grow: 1;

        &__container {
            padding: 30px 60px 30px 30px;

            [class*="desktop"] & {
                font-size: 2.8rem;
                padding: 40px 120px 50px 50px;
            }
        }

        &__label {
            font-size: 1.8rem;
            display: block;
            margin: 0 0 10px;
        }

        &__title {
            font-family: Quicksand-Bold, sans-serif;
            font-size: 2.4rem;
            padding: 0 0 30px;

            [class*="desktop"] & {
                padding: 0 0 6px;
            }

        }

        &__description {
            font-size: 1.9rem;

            &.-modal {
                font-size: 1.8rem;
                line-height: 2.4rem;
            }
        }

        &__actions {
            display: flex;
            margin: 30px 0 0;
            align-items: center;

            [class*="desktop"] & {
                &:after {
                    content: '';
                    flex: 1;
                }
            }
        }

        &__read-more {
            font-size: 1.9rem;
            font-family: Nunito-Bold, sans-serif;
            width: 100%;
            text-align: center;
            &:hover {
                cursor: pointer;
            }
        }

        .icon-plus {
            font-size: 1.8rem;
        }

        .icon-info {
            position: absolute;
            top: 80px;
            right: 32px;
            font-size: 2.5rem
        }

        &__modal {
            padding: 40px 50px;
        }

        &__close-button {
            position: absolute;
            right: 15px;
            top: 15px;
            font-size: 4rem;
            color: $black;
            &:hover {
                opacity: 0.7;
            }
        }
    }
</style>
